import React, { Component, useState } from "react";
import AsyncSwitch from "../AsyncSwitch";
import AdminOnlyWarning from "./AdminOnlyWarning";
import API from "../../utilities/LocalApiProxy";
import { connect } from "react-redux";

const getDocumentStampSettings = () => {
	return API.get("/document/stamping/settings");
};

const getDocIdLine = (stampSettings) => {
	if (stampSettings.documentIdEnabled) {
		return (
			<div>
				<span style={{ fontFamily: "OpenSans-SemiBold" }}>
					DOCUMENT ID:{" "}
				</span>
				123456
			</div>
		);
	}
	return null;
};

const getMatterLine = (stampSettings) => {
	if (stampSettings.matterIdEnabled && stampSettings.matterNameEnabled) {
		return (
			<div>
				<span style={{ fontFamily: "OpenSans-SemiBold" }}>
					MATTER:{" "}
				</span>
				1023, <span>Default Matter Name</span>
			</div>
		);
	} else if (stampSettings.matterIdEnabled) {
		return (
			<div>
				<span style={{ fontFamily: "OpenSans-SemiBold" }}>
					MATTER:{" "}
				</span>
				1023
			</div>
		);
	} else if (stampSettings.matterNameEnabled) {
		return (
			<div>
				<span style={{ fontFamily: "OpenSans-SemiBold" }}>
					MATTER:{" "}
				</span>
				Default Matter Name
			</div>
		);
	}
	return null;
};

const getDocPropsLine = (stampSettings) => {
	let docPropsTitles = [];
	let docPropsValues = [];
	if (stampSettings.documentTypeEnabled) {
		docPropsTitles.push("TYPE:");
		docPropsValues.push("Contract ");
	}
	if (stampSettings.documentStatusEnabled) {
		docPropsTitles.push("STATUS:");
		docPropsValues.push("In Review ");
	}
	if (stampSettings.documentTagsEnabled) {
		docPropsTitles.push("TAGS:");
		docPropsValues.push("Filed With Court, Fully Executed");
	}
	if (docPropsTitles.length) {
		return (
			<div>
				{docPropsTitles.map((title, index) => {
					return (
						<span key={"docProp" + index}>
							<span style={{ fontFamily: "OpenSans-SemiBold" }}>
								{title}{" "}
							</span>
							{docPropsValues[index]}{" "}
						</span>
					);
				})}
			</div>
		);
	}
	return null;
};

const getDocumentStampPreview = (stampSettings) => {
	let line1 = getDocIdLine(stampSettings);
	let line2 = getMatterLine(stampSettings);
	let line3 = getDocPropsLine(stampSettings);

	return (
		<div>
			<h3 style={{ fontSize: 20, marginTop: 50 }}>
				Document Stamp Preview
			</h3>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					marginLeft: 10,
					border: "solid 1px var(--lxw-main-500)",
					padding: 15,
					borderRadius: 4,
				}}
			>
				<div id="docStampLine1">{line1}</div>
				<div id="docStampLine2">{line2}</div>
				<div style={{ display: "flex" }} id="docStampLine3">
					{line3}
				</div>
			</div>
		</div>
	);
};

const DocumentStampSettings = (props) => {
	const [loading, setLoading] = useState(true);
	const [stampSettingsObject, setStampSettingsObject] = useState({
		documentIdEnabled: true,
	});
	const [requestInProgress, setRequestInProgress] = useState(false);

	React.useEffect(() => {
		getDocumentStampSettings()
			.then((res) => {
				if (res.mysql) {
					const { stampSettings } = res.mysql;
					setStampSettingsObject(stampSettings);
					setLoading(false);
				}
			})
			.catch((e) => {
				console.error(
					"error in useEffect for getDocuemntStampSettings",
					e
				);
			});
	}, []);

	const updateDocumentStampObject = (key, newValue, stampSettingsObject) => {
		let updateObject = {
			...stampSettingsObject,
			[key]: newValue,
		};
		return API.post("/document/stamping/settings", {
			body: { documentStampSettings: updateObject },
		})
			.then(() => {
				return Promise.resolve(updateObject);
			})
			.catch((e) => {
				console.log(e);
				setRequestInProgress(false);

				return Promise.reject({ stampSettingsObject });
			});
	};

	const handleSwitchUpdate = ({ newStampSettingsObject }) => {
		setStampSettingsObject(newStampSettingsObject);
		setRequestInProgress(false);
	};

	const createUpdateHandler = (settingKey) => (newValue) => {
		setRequestInProgress(true);
		return updateDocumentStampObject(
			settingKey,
			newValue,
			stampSettingsObject
		).then((newStampSettingsObject) => {
			handleSwitchUpdate({ newStampSettingsObject });
		});
	};

	return (
		<div style={{ width: 700, paddingTop: 20, paddingLeft: 15 }}>
			{props.parentComponentIsLoading || loading ? null : (
				<div>
					<AdminOnlyWarning
						userCanEditSettings={
							props.canEditDocumentStampingSettings
						}
					/>
					<div>
						<h3 style={{ marginTop: 0 }}>
							Firm Wide Document Stamping Settings
						</h3>
						<h5>{`Document Stamping will be enabled for:`}</h5>
					</div>
					<div
						id="enableDisableDocStampSwitches"
						style={{ marginLeft: 10 }}
					>
						<AsyncSwitch
							label={"Matter Documents"}
							switchValue={stampSettingsObject.matterDocsEnabled}
							disabled={
								!props.canEditDocumentStampingSettings ||
								requestInProgress
							}
							loading={loading}
							updateSetting={createUpdateHandler(
								"matterDocsEnabled"
							)}
						/>
						<AsyncSwitch
							label={"Public Firm Documents"}
							switchValue={
								stampSettingsObject.publicFirmDocsEnabled
							}
							disabled={
								!props.canEditDocumentStampingSettings ||
								requestInProgress
							}
							loading={loading}
							updateSetting={createUpdateHandler(
								"publicFirmDocsEnabled"
							)}
						/>
						<AsyncSwitch
							label={"Private Firm Documents"}
							switchValue={
								stampSettingsObject.privateFirmDocsEnabled
							}
							disabled={
								!props.canEditDocumentStampingSettings ||
								requestInProgress
							}
							loading={loading}
							updateSetting={createUpdateHandler(
								"privateFirmDocsEnabled"
							)}
						/>
					</div>
					<div style={{ marginTop: 50 }}>
						<h3>Incuded in Document Stamp (Word Footer)</h3>
						{/* this indentation is off right now */}
						<h5>{`Select the elements you'd like in each document stamp (document footer):`}</h5>
					</div>
					<div id="docStampOptions" style={{ marginLeft: 10 }}>
						<AsyncSwitch
							label={"Document ID (required)"}
							switchValue={stampSettingsObject.documentIdEnabled}
							disabled={true}
							disabledHoverText={
								"Document ID is always included in the document stamp"
							}
							loading={loading}
							updateSetting={createUpdateHandler(
								"documentIdEnabled"
							)}
						/>

						{/* This may be added in the future */}
						{/* <AsyncSwitch
                            label={"Current Version"}
                            switchValue={stampSettingsObject.currentVersionEnabled}
                            disabled={
                                !props.canEditDocumentStampingSettings ||
                                requestInProgress
                            }
                            loading={loading}
                            updateSetting={(newValue) => {
                                setRequestInProgress(true);
                                updateDocumentStampObject(
                                    "currentVersionEnabled",
                                    newValue,
                                    stampSettingsObject
                                ).then((newStampSettingsObject) => {
                                    handleSwitchUpdate({
                                        newStampSettingsObject,
                                        key: "currentVersionEnabled",
                                    });
                                });
                            }}
                        /> */}

						<AsyncSwitch
							label={"Matter ID"}
							switchValue={stampSettingsObject.matterIdEnabled}
							disabled={
								!props.canEditDocumentStampingSettings ||
								requestInProgress
							}
							loading={loading}
							updateSetting={createUpdateHandler(
								"matterIdEnabled"
							)}
						/>

						<AsyncSwitch
							label={"Matter Name"}
							switchValue={stampSettingsObject.matterNameEnabled}
							disabled={
								!props.canEditDocumentStampingSettings ||
								requestInProgress
							}
							loading={loading}
							updateSetting={createUpdateHandler(
								"matterNameEnabled"
							)}
						/>

						<AsyncSwitch
							label={"Document Type"}
							switchValue={
								stampSettingsObject.documentTypeEnabled
							}
							disabled={
								!props.canEditDocumentStampingSettings ||
								requestInProgress
							}
							loading={loading}
							updateSetting={createUpdateHandler(
								"documentTypeEnabled"
							)}
						/>

						<AsyncSwitch
							label={"Document Status"}
							switchValue={
								stampSettingsObject.documentStatusEnabled
							}
							disabled={
								!props.canEditDocumentStampingSettings ||
								requestInProgress
							}
							loading={loading}
							updateSetting={createUpdateHandler(
								"documentStatusEnabled"
							)}
						/>

						<AsyncSwitch
							label={"Document Tags"}
							switchValue={
								stampSettingsObject.documentTagsEnabled
							}
							disabled={
								!props.canEditDocumentStampingSettings ||
								requestInProgress
							}
							loading={loading}
							updateSetting={createUpdateHandler(
								"documentTagsEnabled"
							)}
						/>
					</div>
					{getDocumentStampPreview(stampSettingsObject)}
				</div>
			)}
		</div>
	);
};

// This is a wrapper component for the DocumentStampSettings component
// It sets the subheader text
// It also passes the canEditDocumentStampingSettings prop to the DocumentStampSettings component
class DocumentStampSettingsWrapper extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<DocumentStampSettings
				canEditDocumentStampingSettings={
					this.props.canEditDocumentStampingSettings
				}
				parentComponentIsLoading={this.props.loading}
			/>
		);
	}
}

const mapStateToProps = (state) => ({
	canEditDocumentStampingSettings: state.user.userRights
		? state.user.userRights.UPDATE_DOCUMENT_STAMPING_SETTINGS
		: false,
	loading: state.user.loading,
});
export default connect(mapStateToProps, {})(DocumentStampSettingsWrapper);
